module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_307888696_L-1575d9a86399319e63fa910d4ca6974b.jpg";